import { Card, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { PageContainerCenter } from 'components/PageContainer'
import { useEffect, useState } from 'react'
import EdgeLogo from 'assets/logos/edge-dark-half.png'
import styled from '@emotion/styled'
import WalletConnector from 'components/WalletConnector'
import ApolloLogo from 'assets/logos/apollo.png'

const CustomBox = styled(Box)`
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(18, 18, 18, 0.08);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  margin-top: 32px;
`

interface InfoProps {
  protocolName: string
  invitationLeft: number
}

const Whitelist = () => {
  const [info, setInfo] = useState<InfoProps>({
    protocolName: '',
    invitationLeft: 0,
  })

  useEffect(() => {
    setInfo({
      protocolName: 'Apollo DAO',
      invitationLeft: 30,
    })
  }, [])

  return (
    <PageContainerCenter>
      <Card
        sx={{
          border: 'none',
          width: '444px',
          paddingTop: '48px',
          textAlign: 'center',
        }}
      >
        <img src={ApolloLogo} alt="ApolloLogo" width={121} height={121} />
        <Typography variant="h5" mt="40px">
          {info.protocolName} invites you to join
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <img src={EdgeLogo} alt="EdgeLogo" width={82.8} height={24} />
          <Typography variant="h5">beta launch</Typography>
        </Box>

        <CustomBox>
          <Typography variant="h3" color="primary" mb="-10px">
            {info.invitationLeft}
          </Typography>
          <Typography variant="body1" mb="24px">
            invites left
          </Typography>
          <WalletConnector defaultText="Claim invite with wallet" fullWidth />
        </CustomBox>
      </Card>
    </PageContainerCenter>
  )
}

export default Whitelist
